export function generateHeaders(customerId, token) {
	return {
		headers: {
			Authorization: `Bearer ${token}`,
			'customer-id': customerId,
		},
	};
}
